module.exports = __webpack_public_path__ + "static/img/home_picture_01.c2f3ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/pc/images/home_picture_01.png
// module id = WTKU
// module chunks = 0